import React from 'react';
import '../styles/global.css';

export default function ErrorMessage({ message, onRetry }) {
  return (
    <div className="error-container">
      <div style={{ textAlign: 'center' }}>
        <div className="error-message">
          <h3>⚠️ Error</h3>
          <p>{message}</p>
          {onRetry && (
            <button className="btn btn-primary mt-4" onClick={onRetry}>
              Try Again
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
